import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-category-association',
  templateUrl: './category-association.component.html',
  styleUrls: ['./category-association.component.css']
})
export class CategoryAssociationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
